import { Facebook, Instagram } from "lucide-react";
import { SITE, WA_MESSAGES } from "../data/site";
import { waLink } from "../lib/whatsapp";
import { WhatsAppGlyph } from "./FloatingWhatsApp";

/* Round social buttons for dark backgrounds (footer, closing section).
   A link only renders when its URL is set in SITE (src/data/site.js). */
export const SocialLinks = ({ className = "", testid = "social-links", size = "md" }) => {
    const links = [
        SITE.instagramUrl && {
            key: "instagram",
            label: "033 Digital on Instagram",
            href: SITE.instagramUrl,
            icon: <Instagram size={size === "lg" ? 22 : 19} aria-hidden="true" />,
        },
        SITE.whatsappNumber && {
            key: "whatsapp",
            label: "Chat with 033 Digital on WhatsApp",
            href: waLink(WA_MESSAGES.grow),
            icon: <WhatsAppGlyph size={size === "lg" ? 22 : 19} />,
        },
        SITE.facebookUrl && {
            key: "facebook",
            label: "033 Digital on Facebook",
            href: SITE.facebookUrl,
            icon: <Facebook size={size === "lg" ? 22 : 19} aria-hidden="true" />,
        },
    ].filter(Boolean);

    if (!links.length) return null;

    const box = size === "lg" ? "h-12 w-12" : "h-11 w-11";

    return (
        <ul className={`flex items-center gap-3 ${className}`} data-testid={testid}>
            {links.map((l) => (
                <li key={l.key}>
                    <a
                        href={l.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={l.label}
                        title={l.label}
                        data-testid={`${testid}-${l.key}`}
                        className={`flex ${box} items-center justify-center rounded-full border border-brand-cream/20 text-brand-cream/85 transition-colors duration-200 hover:border-brand-orange hover:bg-brand-orange hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-orange/60`}
                    >
                        {l.icon}
                    </a>
                </li>
            ))}
        </ul>
    );
};
